import { DeviceEntryProps, DeviceType, GatewayEntry, TBeaconEntry, TCoords } from '@ixicare/resources';

export type DBG = GatewayEntry | TBeaconEntry | DeviceEntryProps;

export type DBGWithType = DBG & {
  type: DeviceType;
  subType?: string | null;
};

export enum Status {
  GREEN = 'GREEN', // Device is online (and tested, in case of button).
  OFFLINE = 'OFFLINE', // Device is installed but has never been seen.
  MISSING = 'MISSING', // Device is installed but hasn't reported back in expected time.
  OUTDATED = 'OUTDATED', // Device is installed but has incorrect fw.
  LOW_BATTERY = 'LOW_BATTERY',
  ARCHIVED = 'ARCHIVED',
}

export interface UnifiedDBG {
  id: number;
  type: DeviceType;
  macAddress: string;
  status: Status;

  ownerId?: number;
  swVersion?: string;
  bleVersion?: string;
  batteryLevel?: number;
  chargerConnected?: boolean | null;
  description?: string;
  zoneId?: string;
  planeId?: number;
  installationCoords?: TCoords;
  created?: Date;
  updated?: Date;
  lastSeen?: Date;
}
